<template>
  <v-data-table
    :headers="headers"
    :items="bonus_data"
    sort-by="min_age"
    class="elevation-3"
    disable-pagination
    :hide-default-footer="true"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Bonuses</v-toolbar-title>
        <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
              small
            >
              New Bonus
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.min_age"
                      label="Minimum Age"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.max_age"
                      label="Maximum Age"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field
                      v-model="editedItem.bonus_amount"
                      label="Bonus"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancel
              </v-btn>
              <v-btn color="blue darken-1" text @click="save">
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >Are you sure you want to delete this item?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>
    <!-- eslint-disable-next-line -->
    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
      <v-icon small @click="deleteItem(item)">
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "BonusTable",
  props: ["sa_id", "bonus_data"],

  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "Minimum Age",
        value: "min_age",
      },
      { text: "Maximum Age", value: "max_age" },
      { text: "Bonus", value: "bonus_amount" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    // bonus_data: [],
    editedIndex: -1,
    editedItem: {
      id: 0,
      min_age: null,
      max_age: null,
      bonus_amount: null,
    },
    defaultItem: {
      id: 0,
      min_age: null,
      max_age: null,
      bonus_amount: null,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Bonus" : "Edit Bonus";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      // load data from server
    },

    editItem(item) {
      this.editedIndex = this.bonus_data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.bonus_data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.bonus_data.splice(this.editedIndex, 1);

      this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: Int!) {
              delete_bonus_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.editedItem.id,
          },
        })
        .then(({ data }) => {
          console.log("result", data);
          this.$store.state.snackbar.show = true;
          this.$store.state.snackbar.text = "Bonus Deleted";
        })
        .catch((error) => {
          console.log(error);
          alert("ERROR OCCURED");
        });

      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        // update
        console.log(this.editedItem);

        this.$apollo
          .mutate({
            mutation: gql`
              mutation(
                $id: Int
                $min_age: Int
                $max_age: Int
                $bonus_amount: numeric
              ) {
                update_bonus(
                  where: { id: { _eq: $id } }
                  _set: {
                    bonus_amount: $bonus_amount
                    max_age: $max_age
                    min_age: $min_age
                  }
                ) {
                  returning {
                    id
                    bonus_amount
                    max_age
                    min_age
                  }
                }
              }
            `,
            variables: {
              id: this.editedItem.id,
              min_age: this.editedItem.min_age,
              max_age: this.editedItem.max_age,
              bonus_amount: this.editedItem.bonus_amount,
            },
          })
          .then(({ data }) => {
            console.log(data);
            this.$store.state.snackbar.show = true;
            this.$store.state.snackbar.text = "Bonus Updated";
          })
          .catch((error) => {
            console.log(error);
            alert("ERROR OCCURED");
          });

        Object.assign(this.bonus_data[this.editedIndex], this.editedItem);
      } else {
        // create
        this.$apollo
          .mutate({
            mutation: gql`
              mutation(
                $state_availability_id: Int
                $min_age: Int
                $max_age: Int
                $bonus_amount: numeric
              ) {
                insert_bonus_one(
                  object: {
                    state_availability_id: $state_availability_id
                    min_age: $min_age
                    max_age: $max_age
                    bonus_amount: $bonus_amount
                  }
                ) {
                  id
                  min_age
                  max_age
                  bonus_amount
                }
              }
            `,
            variables: {
              state_availability_id: this.sa_id,
              min_age: this.editedItem.min_age,
              max_age: this.editedItem.max_age,
              bonus_amount: this.editedItem.bonus_amount,
            },
          })
          .then(({ data }) => {
            console.log(data);
            this.bonus_data.push(data.insert_bonus_one);
            this.$store.state.snackbar.show = true;
            this.$store.state.snackbar.text = "Bonus created";
          })
          .catch((error) => {
            console.log(error);
            alert("ERROR OCCURED");
          });
      }
      this.close();
    },
  },
};
</script>
